export const balanceDataOfTwoPhase: number[][] = [
  // [5, 59],
  // [10, 89],
  [25, 199],
  [50, 379],
  [100, 599],
  [200, 1299],
  [500, 1999],
  [1000, 4999],
];

export const balanceDataOfInstantFunding: number[][] = [
  // [5, 149],
  // [10, 279],
  [25, 699],
  [50, 1299],
  [100, 1999],
  [200, 2999],
  [500, 4999],
  [1000, 9999],
];

export const balanceDataOfInstantFundingLite: number[][] = [
  // [5, 109],
  // [10, 229],
  [25, 549],
  [50, 849],
  [100, 1399],
  [200, 1999],
  [500, 3279],
  [1000, 6749],
];

// One-Step (Step 1) pricing (keep aligned with PricingComparisionTable)
export const balanceDataOfOneStep: number[][] = [
  // [10, 149],
  [25, 299],
  [50, 479],
  [100, 999],
  [200, 1649],
  [500, 2499],
  [1000, 2999],
];
